// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Utils__Regex = require("../../../utils/Utils__Regex.bs.js");
let Form__Helpers = require("./Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let EmailRegexJs = require("./emailRegex.js").default;
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Form__Validators__Email = require("./Form__Validators__Email.bs.js");

function isRequired(str) {
  let x = Stdlib_Option.map(str, prim => prim.trim());
  if (x !== undefined && x !== "") {
    return {
      TAG: "Ok",
      _0: "Valid"
    };
  } else {
    return {
      TAG: "Error",
      _0: "is required"
    };
  }
}

let emailRegex = EmailRegexJs;

function isEmail(email) {
  if (Form__Validators__Email.isEmail(email)) {
    return {
      TAG: "Ok",
      _0: "Valid"
    };
  } else {
    return {
      TAG: "Error",
      _0: "must be a valid email address"
    };
  }
}

function isPhone(phone) {
  if (Form__Helpers.stripNonDigits(phone).length === 10) {
    return {
      TAG: "Ok",
      _0: "Valid"
    };
  } else {
    return {
      TAG: "Error",
      _0: "must be a valid, 10 digit phone number"
    };
  }
}

function boolOfValidation(x) {
  if (x.TAG === "Ok") {
    return x._0 === "Valid";
  } else {
    return false;
  }
}

function makeNameRegexStr(param) {
  let firstNameEscaped = Utils__Regex.escape(param.firstName);
  let lastNameEscaped = Utils__Regex.escape(param.lastName);
  return `\\b` + firstNameEscaped + `\\s+` + lastNameEscaped + `\\b`;
}

function makeDisplayNameRegexStr(displayName) {
  let str = displayName.split(" ").filter(x => x !== "").map(Utils__Regex.escape).join("\\s+");
  return `\\b` + str + `\\b`;
}

function makeRegex(currentUser, accountOwner) {
  let regexes = Stdlib_List.concat({
    hd: Utils__Regex.phoneRegexStr,
    tl: {
      hd: Utils__Regex.emailRegexStr,
      tl: {
        hd: makeNameRegexStr(currentUser),
        tl: {
          hd: Stdlib_Option.map(currentUser.displayName, makeDisplayNameRegexStr),
          tl: /* [] */0
        }
      }
    }
  }, currentUser.id === accountOwner.id ? /* [] */0 : ({
      hd: makeNameRegexStr(accountOwner),
      tl: {
        hd: Stdlib_Option.map(accountOwner.displayName, makeDisplayNameRegexStr),
        tl: /* [] */0
      }
    }));
  let list = Stdlib_List.filterMap(regexes, x => x);
  return new RegExp(Utils.List.join("|", undefined, list), "i");
}

function validate(currentUser, accountOwner, text) {
  let regex = makeRegex(currentUser, accountOwner);
  let res = Stdlib_Option.map(Primitive_option.fromNullable(regex.exec(text)), v => v.slice(1));
  if (res !== undefined) {
    return {
      TAG: "Error",
      _0: res[0]
    };
  } else {
    return {
      TAG: "Ok",
      _0: "Valid"
    };
  }
}

let PersonalInfoValidation = {
  makeNameRegexStr: makeNameRegexStr,
  makeDisplayNameRegexStr: makeDisplayNameRegexStr,
  makeRegex: makeRegex,
  validate: validate
};

exports.isRequired = isRequired;
exports.emailRegex = emailRegex;
exports.isEmail = isEmail;
exports.isPhone = isPhone;
exports.boolOfValidation = boolOfValidation;
exports.PersonalInfoValidation = PersonalInfoValidation;
/* emailRegex Not a pure module */
